module.exports = __webpack_public_path__ + "assets/img/prices.c24ebd4a.svg";